/** Opções rápidas de quando enviar cada lembrete (após o PIX gerado) */
export const TIMING_OPTIONS = [
  { label: "10 minutos após gerar PIX", delay_value: 10, delay_unit: "m" },
  { label: "20 minutos após gerar PIX", delay_value: 20, delay_unit: "m" },
  { delay_value: 30, delay_unit: "m", label: "30 minutos após gerar PIX" },
  { delay_value: 40, delay_unit: "m", label: "40 minutos após gerar PIX" },
  { delay_value: 50, delay_unit: "m", label: "50 minutos após gerar PIX" },
  { delay_value: 1, delay_unit: "h", label: "1 hora após gerar PIX" },
  { delay_value: 2, delay_unit: "h", label: "2 horas após gerar PIX" },
  { delay_value: 6, delay_unit: "h", label: "6 horas após gerar PIX" },
  { delay_value: 24, delay_unit: "h", label: "24 horas após gerar PIX" },
];

export const VARIABLE_BUTTONS = [
  { label: "Nome", value: "{{nome}}" },
  { label: "Valor", value: "{{valor}}" },
  { label: "Produto", value: "{{produto}}" },
  { label: "Código PIX", value: "{{pix}}" },
  { label: "Link de pagamento", value: "{{link_pagamento}}" },
];

export const READY_MESSAGES = [
  {
    label: "Mensagem leve",
    text: "Oi {{nome}}, vi que você gerou o PIX, mas ainda não finalizou. Quer que eu te envie novamente?",
  },
  {
    label: "Mensagem de ajuda",
    text: "Seu pagamento ainda ficou pendente. Se tiver tido algum problema para pagar, posso te ajudar por aqui.",
  },
  {
    label: "Mensagem com urgência leve",
    text: "Seu pedido ainda está reservado, mas o PIX pode expirar em breve. Quer concluir agora?",
  },
  {
    label: "Última tentativa",
    text: "Último lembrete: sua compra ficou pendente. Se ainda tiver interesse, me chama aqui que eu te ajudo a finalizar.",
  },
];

export const CONTENT_TYPE_OPTIONS = [
  { id: "text", label: "Texto" },
  { id: "image", label: "Imagem" },
  { id: "image_caption", label: "Imagem com legenda" },
  { id: "audio", label: "Áudio" },
];

const PREVIEW_CTX = {
  nome: "Maria",
  valor: "R$ 29,90",
  produto: "Plano Mensal",
  pix: "00020126580014BR.GOV.BCB.PIX0136...",
  link_pagamento: "https://pagamento.convertpix.example/abc123",
};

export function substituteVariables(text) {
  if (!text) return "";
  return text
    .replace(/\{\{nome\}\}/gi, PREVIEW_CTX.nome)
    .replace(/\{\{valor\}\}/gi, PREVIEW_CTX.valor)
    .replace(/\{\{produto\}\}/gi, PREVIEW_CTX.produto)
    .replace(/\{\{pix\}\}/gi, PREVIEW_CTX.pix)
    .replace(/\{\{link_pagamento\}\}/gi, PREVIEW_CTX.link_pagamento);
}

export function delayLabel(step) {
  const n = Number(step?.delay_value || 0);
  const u = String(step?.delay_unit || "m");
  if (u === "m") return `${n} minuto${n === 1 ? "" : "s"}`;
  if (u === "h") return `${n} hora${n === 1 ? "" : "s"}`;
  if (u === "d") return `${n} dia${n === 1 ? "" : "s"}`;
  return `${n}${u}`;
}

export function contentTypeLabel(type) {
  if (type === "audio") return "Áudio";
  if (type === "image") return "Imagem";
  if (type === "image_caption") return "Imagem com legenda";
  return "Texto";
}

/** Rótulo amigável: "10 minutos após gerar PIX" */
export function timingPhrase(step) {
  const n = Number(step?.delay_value || 0);
  const u = String(step?.delay_unit || "m");
  if (u === "m") return `${n} minuto${n === 1 ? "" : "s"} após gerar PIX`;
  if (u === "h") return `${n} hora${n === 1 ? "" : "s"} após gerar PIX`;
  if (u === "d") return `${n} dia${n === 1 ? "" : "s"} após gerar PIX`;
  return delayLabel(step);
}

export function findTimingSelectValue(step) {
  const hit = TIMING_OPTIONS.find((o) => o.delay_value === Number(step?.delay_value) && o.delay_unit === (step?.delay_unit || "m"));
  return hit ? `${hit.delay_value}_${hit.delay_unit}` : "__custom";
}

export function stepOrdinalLabel(index) {
  const names = ["Primeiro lembrete", "Segundo lembrete", "Terceiro lembrete", "Quarto lembrete", "Quinto lembrete"];
  return names[index] || `Lembrete ${index + 1}`;
}

export function stepToApiPayload(step) {
  return {
    order: Number(step.order ?? 0),
    delay_value: Number(step.delay_value ?? 10),
    delay_unit: step.delay_unit || "m",
    message_model_id: step.message_model_id || null,
    step_label: step.step_label || null,
    content_type: step.content_type || "text",
    text_content: step.text_content || "",
    media_url: step.media_url || null,
    caption: step.caption || "",
    active: step.active !== false,
    mimetype: step.mimetype || null,
    filename: step.filename || null,
  };
}
